'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'person-dolly';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f4d0';
var svgPathData = 'M507.6 391.8c-1.1-4.3-5.5-6.8-9.8-5.7l-20.3 5.4-40.7-151.8c-4.6-17.1-22.1-27.2-39.2-22.6l-127.1 34c.9-3.6 1.5-7.3 1.5-11.2 0-23.6-17.2-43.2-39.7-47.2L208 101.9c-1.1-4.3-5.5-6.8-9.8-5.7l-15.5 4.1c-4.3 1.1-6.8 5.5-5.7 9.8l21.8 81.8h-3l-56.6-56.6c-2.4-2.4-5.1-4.2-7.7-6.3 7.1-5.4 13.2-12 18-19.9 10-16.4 12.9-35.8 8.3-54.5C150 22.5 121.2 0 88 0 66.3 0 41.2 10.3 26.4 34.7c-10 16.4-12.9 35.8-8.3 54.5 3.4 13.8 10.7 25.6 20.4 34.8C15.6 138.1 0 163.4 0 192v272c0 26.5 21.5 48 48 48s48-21.5 48-48v-66l3.6 3.1 13.1 71.5c4.4 23.8 27.8 43.8 56 38.5 12.5-2.3 23.4-9.4 30.7-19.9 7.3-10.6 10-23.3 7.7-35.9L193 378.7c-3.4-18.3-13-35.1-27.2-47.1L128 299.1v-39.2l28.1 28.1H224c.2 0 .4-.1.6-.1l28.5 106.5C235.6 405.8 224 425.5 224 448c0 35.3 28.7 64 64 64 31.7 0 57.8-23.1 62.9-53.4L506.1 417c4.3-1.1 6.8-5.5 5.7-9.8l-4.2-15.4zM88 32c18 0 34.3 12.2 38.8 30.5C133.5 89.6 112 112 88 112c-18 0-34.3-12.2-38.8-30.5C42.5 54.4 64 32 88 32zM64 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V343.2l32 27.4V464zm105.4-208l-59.7-59.7c-1.6-1.6-3.6-2.4-5.6-2.4-4.1 0-8.1 3.2-8.1 8v111.9l49.2 42.1c8.6 7.3 14.4 17.5 16.5 28.6l14.1 76.6c1.6 8.7-4.2 17-12.8 18.6-1 .2-2 .3-2.9.3-7.6 0-14.3-5.4-15.7-13.1l-14.1-76.5c-.7-3.9-2.8-7.5-5.8-10.1l-75.6-64.7C38.1 306.3 32 293.1 32 279v-87c0-25.6 20.3-47.2 45.9-48H80c15.4 0 27.8 5.1 36.7 14.1l65.9 65.9H224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-54.6zM288 480c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm60-53.8c-8.9-24.6-32.3-42.3-60-42.3-1.5 0-2.9.3-4.4.4l-25.9-96.6L405.9 248l40.7 151.8-98.6 26.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faPersonDolly = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;